import { Input } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'

export default withStyles({
  root: {
    borderRadius: 50,
    border: '1px solid #ced4da',
    flex: 1,
    '&::before': {
      display: 'none'
    },
    '&::after': {
      display: 'none'
    }
  },
  input: {
    borderRadius: 25,
    position: 'relative',
    fontWeight: 400,
    fontSize: 14,
    width: '100%',
    padding: '10px 25px',
    display: 'flex',
    alignItems: 'center',
    boxShadow: 'none',
    '&:focus': {
      borderColor: '#3700D7'
    },
    '&::placeholder': {
      fontWeight: 400,
      fontSize: 14
    }
  },
  inputTypeSearch: {
    fontSize: 20,
    padding: 7,
    fontWeight: 400,
    border: 'none !important',
    boxShadow: '0px 1px 3px 0px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 2px 1px -1px rgba(0,0,0,0.12)',
    '&::before': {
      display: 'none'
    }
  },
  multiline: {
    borderRadius: 25,
    padding: 0,
    '& textarea': {
      minHeight: 41,
      boxSizing: 'border-box'
    }
  }
})(Input)
